import { cdnTemplate } from 'cdnPreprocessor';

export default['$stateProvider',
  function($stateProvider) {
    $stateProvider.state('open-shop', {
      abstract: true,
      template: '<ui-view></ui-view>',
      url: '/open-shop'
    }).state('open-shop.overview', {
      url: '',
      templateUrl: cdnTemplate('/overview.html')
    }).state('open-shop.artists', {
      url: '/artists',
      templateUrl: cdnTemplate('/artists.html')
    })
    .state('open-shop.bloggers', {
      url: '/bloggers',
      templateUrl: cdnTemplate('/bloggers.html')
    })
    .state('open-shop.brands', {
      url: '/brands',
      templateUrl: cdnTemplate('/brands.html')
    })
    .state('open-shop.sports', {
      url: '/sports',
      templateUrl: cdnTemplate('/sports.html')
    })
    .state('open-shop.esports', {
      url: '/esports',
      templateUrl: cdnTemplate('/esports.html')
    })
    .state('open-shop.affiliates', {
      url: '/affiliates',
      templateUrl: cdnTemplate('/affiliates.html')
    })
    .state('open-shop.musicians', {
      url: '/musicians',
      templateUrl: cdnTemplate('/musicians.html')
    })
    .state('open-shop.youtubers', {
      url: '/youtubers',
      templateUrl: cdnTemplate('/youtubers.html')
    })
    ;
  }
];



// WEBPACK FOOTER //
// ./source/client/pages/open-shop/open-shop.routes.js